export default "/_next/static/images/0a2e947da1038e8787e9bf5499d58b9f.png";